import { UtilizationPrice } from '@/api';
import { dynPricingDayOfWeek } from '@/utils/dateUtils';

export function useTimeWindowOverlap() {
  function isOverlapping(
    newEvent: UtilizationPrice,
    existingEvents: UtilizationPrice[]
  ): boolean {
    if (
      !newEvent.startTime ||
      !newEvent.endTime ||
      newEvent.dayOfTheWeek == null
    ) {
      return true;
    }

    const newStartTime = parseTimeString(newEvent.startTime);
    const newEndTime = parseTimeString(newEvent.endTime);
    const newDayOfWeek = dynPricingDayOfWeek(newEvent.dayOfTheWeek);

    return existingEvents.some((existingEvent) => {
      if (existingEvent.dayOfTheWeek !== newDayOfWeek) {
        return false;
      }

      if (!existingEvent.startTime || !existingEvent.endTime) {
        return true;
      }

      const existingStartTime = parseTimeString(existingEvent.startTime);
      const existingEndTime = parseTimeString(existingEvent.endTime);

      return newStartTime < existingEndTime && newEndTime > existingStartTime;
    });
  }

  function parseTimeString(timeString: string): Date {
    const hasDatePrefix = timeString.split('T').length > 1;
    return hasDatePrefix
      ? new Date(timeString)
      : new Date(`1900-01-01T${timeString}`);
  }

  function isWithinValidHours(
    startTime: Date,
    endTime: Date,
    validHours: { startTime: string; endTime: string }
  ): boolean {
    const [startHour, startMinute] = validHours.startTime
      .split(':')
      .map(Number);
    const [endHour, endMinute] = validHours.endTime.split(':').map(Number);

    const validStartTime = new Date(startTime);
    validStartTime.setHours(startHour, startMinute);

    const validEndTime = new Date(endTime);
    validEndTime.setHours(endHour, endMinute);

    return (
      startTime >= validStartTime &&
      endTime <= validEndTime &&
      startTime.getDay() === endTime.getDay()
    );
  }

  return {
    isOverlapping,
    isWithinValidHours,
    parseTimeString,
  };
}
